<template>
  <div class="doc-menu">
    <Menu
      ref="menu"
      theme="light"
      mode="vertical"
      :active-name="activeKey"
      :open-names="openName"
      :accordion="true"
      v-if="dataList.length"
    >
      <template v-for="item in dataList">
        <Submenu
          v-if="item.children && item.children.length"
          :name="item.menuCode"
          :key="item.catalogCode"
          v-show="item.menuDisplay"
        >
          <template slot="title">
            {{ item.menuName }}
          </template>

          <template v-for="cell in item.children">
            <Submenu
              v-if="cell.children && cell.children.length"
              :name="cell.menuCode"
              :key="cell.catalogCode"
              v-show="cell.menuDisplay"
            >
              <template slot="title">
                {{ cell.menuName }}
              </template>
              <Menu-item
                v-for="list in cell.children"
                :key="list.catalogCode"
                :name="list.menuCode"
                :to="
                  list.route
                    ? list.route
                    : {
                        name: route[item.routeName],
                        params: { menuCode: list.menuCode }
                      }
                "
                v-show="list.menuDisplay"
              >
                {{ list.menuName }}
              </Menu-item>
            </Submenu>
            <Menu-item
              v-else
              :key="cell.catalogCode"
              :name="cell.menuCode"
              :to="
                cell.route
                  ? cell.route
                  : {
                      name: route[item.routeName],
                      params: { menuCode: cell.menuCode }
                    }
              "
              v-show="cell.menuDisplay"
            >
              {{ cell.menuName }}
            </Menu-item></template
          >
        </Submenu>
        <Menu-item
          v-else
          :key="item.catalogCode"
          :name="item.menuCode"
          :to="
            item.route
              ? item.route
              : {
                  name: route[item.routeName],
                  params: { menuCode: item.menuCode }
                }
          "
          v-show="item.menuDisplay"
        >
          {{ item.menuName }}
        </Menu-item>
      </template>
    </Menu>
  </div>
</template>

<script>
import { findTreeParent } from "@/config/utils";
export default {
  props: {
    dataList: {
      type: Array,
      required: true,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      activeKey: this.$route.params.menuCode,
      route: {
        faq: "docFaqList",
        technical: "docTechnologyList",
        product: "docProductList",
        notice: "docNoticeList"
      },
      openName: []
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.init();
  },
  watch: {
    $route() {
      this.activeKey = this.$route.params.menuCode;
      this.init();
    },
    dataList() {
      this.init();
      console.log("dataList=", this.dataList);
    }
  },
  methods: {
    init() {
      /* this.dataList.forEach(item => {
        if (item.menuCode !== this.$route.params.menuCode) {
          if (item.children && item.children.length) {
            item.children.forEach(cell => {
              if (cell.menuCode === this.$route.params.menuCode) {
                this.openName = [item.menuCode];
              }
            });
          }
        }
      }); */
      this.openName = findTreeParent(
        this.dataList,
        item => item.menuCode === this.$route.params.menuCode,
        "children"
      ).map(item => item.menuCode);

      this.$nextTick(() => {
        this.$refs.menu && this.$refs.menu.updateOpened();
        this.$refs.menu.updateActiveName();
      });
    }
  },
  components: {}
};
</script>

<style lang="less">
.doc-menu {
  width: 240px;
  .ivu-menu-light.ivu-menu-vertical
    .ivu-menu-item-active:not(.ivu-menu-submenu) {
    background: #f0f6ff;
    color: @color-primary;
    &::after {
      background: @color-primary;
    }
  }
  .ivu-menu-vertical .ivu-menu-item:hover,
  .ivu-menu-vertical .ivu-menu-submenu-title:hover {
    color: @color-primary;
  }
  .ivu-menu-submenu .ivu-menu-item {
    padding: 2px 24px;
    margin-bottom: 15px;
  }

  .ivu-menu-item {
    min-height: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .remark {
    font-size: 12px;
    color: @color-font-info;
  }
}
</style>
